"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isQuestionPrescribe = exports.isQuestionSjtTwoAnswer = exports.isQuestionRanking = exports.isQuestionSelect3 = exports.isQuestionEMQ = exports.isQuestionMultiQ = exports.isQuestionQA = exports.isQuestionSBA = exports.EQuestionLike = exports.EQuestionType = exports.EVeracityAnswer = exports.EPsaSectionType = void 0;
var EPsaSectionType;
(function (EPsaSectionType) {
    EPsaSectionType[EPsaSectionType["PRESCRIBING"] = 1] = "PRESCRIBING";
    EPsaSectionType[EPsaSectionType["PRESCRIPTION_REVIEW"] = 2] = "PRESCRIPTION_REVIEW";
    EPsaSectionType[EPsaSectionType["PLANNING_MANAGEMENT"] = 3] = "PLANNING_MANAGEMENT";
    EPsaSectionType[EPsaSectionType["PROVIDING_INFORMATION"] = 4] = "PROVIDING_INFORMATION";
    EPsaSectionType[EPsaSectionType["CALCULATION_SKILLS"] = 5] = "CALCULATION_SKILLS";
    EPsaSectionType[EPsaSectionType["ADVERSE_DRUG_REACTION"] = 6] = "ADVERSE_DRUG_REACTION";
    EPsaSectionType[EPsaSectionType["DRUG_MONITORING"] = 7] = "DRUG_MONITORING";
    EPsaSectionType[EPsaSectionType["DATA_INTERPRETATION"] = 8] = "DATA_INTERPRETATION";
})(EPsaSectionType = exports.EPsaSectionType || (exports.EPsaSectionType = {}));
var EVeracityAnswer;
(function (EVeracityAnswer) {
    EVeracityAnswer["TRUE"] = "a";
    EVeracityAnswer["FALSE"] = "b";
    EVeracityAnswer["UNCERTAIN"] = "c";
})(EVeracityAnswer = exports.EVeracityAnswer || (exports.EVeracityAnswer = {}));
var EQuestionType;
(function (EQuestionType) {
    EQuestionType[EQuestionType["SINGLE_BEST_ANSWER"] = 1] = "SINGLE_BEST_ANSWER";
    EQuestionType[EQuestionType["QUESTION_ANSWER"] = 2] = "QUESTION_ANSWER";
    EQuestionType[EQuestionType["MULTIPLE_ANSWERS"] = 3] = "MULTIPLE_ANSWERS";
    EQuestionType[EQuestionType["PRESCRIPTION_ANSWER"] = 4] = "PRESCRIPTION_ANSWER";
    EQuestionType[EQuestionType["EXTENDED_MATCHING_ANSWER"] = 5] = "EXTENDED_MATCHING_ANSWER";
    EQuestionType[EQuestionType["SELECT_THREE_ANSWER"] = 6] = "SELECT_THREE_ANSWER";
    EQuestionType[EQuestionType["RANKING_ANSWER"] = 7] = "RANKING_ANSWER";
    EQuestionType[EQuestionType["SBA_WITH_MULTIPLE_CHOICES"] = 8] = "SBA_WITH_MULTIPLE_CHOICES";
    EQuestionType[EQuestionType["VERBAL_VERACITY"] = 9] = "VERBAL_VERACITY";
    EQuestionType[EQuestionType["VERBAL_READING_COMPREHENSION"] = 10] = "VERBAL_READING_COMPREHENSION";
    EQuestionType[EQuestionType["QUANTITATIVE_REASONING_SBA"] = 11] = "QUANTITATIVE_REASONING_SBA";
    EQuestionType[EQuestionType["DECISION_MAKING_SBA"] = 12] = "DECISION_MAKING_SBA";
    EQuestionType[EQuestionType["DECISION_MAKING_YES_NO"] = 13] = "DECISION_MAKING_YES_NO";
    EQuestionType[EQuestionType["SJT_SINGLE_CHOICE"] = 14] = "SJT_SINGLE_CHOICE";
    EQuestionType[EQuestionType["SJT_TWO_ANSWERS"] = 15] = "SJT_TWO_ANSWERS";
})(EQuestionType = exports.EQuestionType || (exports.EQuestionType = {}));
var EQuestionLike;
(function (EQuestionLike) {
    EQuestionLike[EQuestionLike["NONE"] = 0] = "NONE";
    EQuestionLike[EQuestionLike["LIKE"] = 1] = "LIKE";
    EQuestionLike[EQuestionLike["DISLIKE"] = 2] = "DISLIKE";
})(EQuestionLike = exports.EQuestionLike || (exports.EQuestionLike = {}));
function isQuestionSBA(data) {
    return [
        EQuestionType.SINGLE_BEST_ANSWER,
        EQuestionType.SBA_WITH_MULTIPLE_CHOICES,
        EQuestionType.VERBAL_VERACITY,
        EQuestionType.VERBAL_READING_COMPREHENSION,
        EQuestionType.DECISION_MAKING_SBA,
        EQuestionType.QUANTITATIVE_REASONING_SBA,
        EQuestionType.SJT_SINGLE_CHOICE,
    ].includes(data.typeId);
}
exports.isQuestionSBA = isQuestionSBA;
function isQuestionQA(data) {
    return data.typeId === EQuestionType.QUESTION_ANSWER;
}
exports.isQuestionQA = isQuestionQA;
function isQuestionMultiQ(data) {
    return [
        EQuestionType.MULTIPLE_ANSWERS,
        EQuestionType.DECISION_MAKING_YES_NO,
    ].includes(data.typeId);
}
exports.isQuestionMultiQ = isQuestionMultiQ;
function isQuestionEMQ(data) {
    return data.typeId === EQuestionType.EXTENDED_MATCHING_ANSWER;
}
exports.isQuestionEMQ = isQuestionEMQ;
function isQuestionSelect3(data) {
    return data.typeId === EQuestionType.SELECT_THREE_ANSWER;
}
exports.isQuestionSelect3 = isQuestionSelect3;
function isQuestionRanking(data) {
    return data.typeId === EQuestionType.RANKING_ANSWER;
}
exports.isQuestionRanking = isQuestionRanking;
function isQuestionSjtTwoAnswer(data) {
    return data.typeId === EQuestionType.SJT_TWO_ANSWERS;
}
exports.isQuestionSjtTwoAnswer = isQuestionSjtTwoAnswer;
function isQuestionPrescribe(data) {
    return data.typeId === EQuestionType.PRESCRIPTION_ANSWER;
}
exports.isQuestionPrescribe = isQuestionPrescribe;
